import { Component, inject, input, OnInit } from '@angular/core'
import {
  cancellationReasonsByGoal,
  CancelSubscriptionReason,
  Experiment,
} from '@naturalcycles/shared'
import { ExperimentService } from '@src/app/core/services/experiment.service.js'
import { getSignalStore } from '@src/app/core/store/signalStore.js'

@Component({
  templateUrl: 'cancellation-reasons-modal.component.html',
  selector: 'cancellation-reasons-modal',
  styleUrls: ['cancellation-reasons-modal.component.scss'],
  standalone: false,
})
export class CancellationReasonsModalComponent implements OnInit {
  private experimentService = inject(ExperimentService)

  public reasons = cancellationReasonsByGoal(getSignalStore().$account().goal)
  public selectedReason: CancelSubscriptionReason | undefined = undefined

  protected api = input.required<{ select: (b: CancelSubscriptionReason) => void }>()

  public selectReason(): void {
    this.api().select(this.selectedReason!)
  }

  async ngOnInit(): Promise<void> {
    await this.experimentService.logImpression(Experiment.CANCELLATION_FLOW_REIMBURSEMENT)
  }
}
